import templateUrl from 'emun.invoice/invoice-one-up.htm'
import InvoiceOneUpController from 'emun.invoice/invoice-one-up.controller'

export default {
    bindings: {
        invoice: '<',
        invoiceLines: '<',
    },
    controller: InvoiceOneUpController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};